var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJamCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3964 17.2796C11.2651 17.2798 11.1351 17.2542 11.0138 17.2041C10.8924 17.154 10.7822 17.0804 10.6894 16.9876L6.44739 12.7446C6.35182 12.6524 6.27556 12.5421 6.22306 12.4201C6.17057 12.2982 6.14289 12.167 6.14165 12.0342C6.1404 11.9014 6.16561 11.7697 6.2158 11.6468C6.266 11.5239 6.34017 11.4122 6.43399 11.3182C6.52782 11.2242 6.63942 11.1499 6.76228 11.0995C6.88514 11.0492 7.0168 11.0238 7.14958 11.0248C7.28236 11.0259 7.41359 11.0534 7.53563 11.1057C7.65767 11.158 7.76807 11.2341 7.86039 11.3296L11.3954 14.8646L17.7604 8.50158C17.9479 8.31394 18.2023 8.20847 18.4675 8.20837C18.7328 8.20828 18.9872 8.31357 19.1749 8.50108C19.3625 8.68858 19.468 8.94295 19.4681 9.20822C19.4682 9.47349 19.3629 9.72794 19.1754 9.91558L12.1034 16.9876C12.0106 17.0804 11.9003 17.154 11.779 17.2041C11.6577 17.2542 11.5277 17.2798 11.3964 17.2796Z",
    fill: "#2FAB73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamCheck);
export default __webpack_public_path__ + "static/media/jam_check.3299e2a73cfd436c1b8bbc2fa43f070c.svg";
export { ForwardRef as ReactComponent };